'use strict'

export let english={
  general: {
    login: "Login",
    profile: "Profile",
    searchCriteria: "Enter search criteria",
    search: "Search",
    addProject: "Add project",
    filterProjects: "Filter projects",
    projectMenu: "Project menu",
    otherPortfolio: "Other",
    unknownTenantName: "Your name",
    sections: {
      programmes: "Programmes",
      projects: "Projects",
      projectsAndReleases: "Projects and Releases",
      releases: "Releases",
      products: "Products and Platforms"
    }
  },
  requestedStageTransition: "Requested",
  requestedPhase: "Requested phase",
  projectStatus: {
    stopped: "stopped",
    paused: "paused"
  },
  columns: {
    portfolio: "Portfolio",
    numberOfProjects: "# Activities",
    priority: "Priority",
    name: "Name",
    status: "Status",
    stage: "Part",
    benefits: "Benefits",
    time: "Time",
    cost: "Cost",
    quality: "Quality",
    scope: "Scope",
    risk: "Risk"
  },
  inactive: {
    hide: "Hide inactive projects",
    show: "Show {0} inactive project{1}",
    projectsPlural: "s"
  },
  prioritize: {
    drop: "Drop your prioritized project or release here"
  },
  empty: "No projects in portfolio, please add a project.",
  programme: {
    columns: {
      name: "Programme Name",
      stage: "Tranche"
    },
    prioritize: {
      drop: "Drop your prioritized programmes here"
    },
    inactive: {
      hide: "Hide inactive programmes",
      show: "Show {0} inactive programme{1}"
    }
  },
  product: {
    noActiveReleases: "No active release",
    columns: {
      name: "Product Name",
      stage: "Release"
    },
    prioritize: {
      drop: "Drop your prioritized products here"
    },
    inactive: {
      hide: "Hide inactive products",
      show: "Show {0} inactive product{1}"
    }
  }
};



// WEBPACK FOOTER //
// ./views/portfolio/labels/english.js